import React from 'react';
import { Link } from 'react-router-dom';

export default function MyAccessTokens({
  totalAccessNftCount = 0,
  closeDrawer = () => {}
}) {
  return (
    <div className="my-buckes">
      <div className="balances mb-4">
        <div className="bal">
          <span>Total Access NFTs</span>
          <span className="amount">{totalAccessNftCount}</span>
        </div>
        <div className="liat-cart-slide">
          <div className="collecton px-4 pt-4">
            <div className="images large-img">
              <img
                src={require('./Images/AccessNFTs-Dummy-Group.webp')}
                alt=""
              />
            </div>
            <div className="details">
              {/* <div className="amount">$50,000</div> */}
              <Link
                to="/StakeHub/AccessNFT"
                onClick={() => closeDrawer(true)}
                className="collection-link"
              >
                View My Access NFTs
              </Link>
              {/* <Link to="/" className="more-link">Purchase History </Link> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
